import Text from '@zenbusiness/common-components/Text';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import { useStyles } from './useStyles';

export const CardItem = ({
  text, align, textColor, bgColor, isCollectionTitle, className
}) => {
  const classes = useStyles({ bgColor });

  return (
    <Box data-testid="item-box" className={classNames(classes.itemBox, className)}>
      <Text
        align={align}
        size={isCollectionTitle ? 'md' : 'sm'}
        bold
        color={textColor}
        className={classes.itemText}
      >
        {text}
      </Text>
    </Box>
  );
};

CardItem.propTypes = {
  text: PropTypes.string,
  align: PropTypes.oneOf(['left', 'center']),
  textColor: PropTypes.oneOf(['focus00', 'focus90']),
  bgColor: PropTypes.string,
  isCollectionTitle: PropTypes.bool
};

CardItem.defaultProps = {
  text: 'Item',
  align: 'left',
  textColor: 'focus00',
  bgColor: '#000000',
  isCollectionTitle: false
};
